export enum FeatureCareCalendarInputNames {
  CareCalendarEnabled = 'careCalendarEnabled',
}
